import React from "react";
import "../styles/About.css";
import YugrajSaini from "../images/YugrajSaini.jpeg";
import { Helmet } from "react-helmet-async";
// import AboutGallery from "../component/AboutGallery";
function About() {
  return (
    <>
      <Helmet>
        <title>About Us | PlanBanaLo</title>
        <meta
          name="description"
          content="Learn about PlanBanaLo and our mission to provide unforgettable camping and retreat experiences."
        />
      </Helmet>
      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-container">
          <h1>About PlanBanLo</h1>
          <p>
            Crafting unforgettable Himalayan yoga retreats and camping
            experiences that reconnect you with nature, stillness, and your
            true self.
          </p>
        </div>
      </section>

      {/* Who We Are */}
      <section className="about-section">
        <div className="about-content">
          <h2>Who We Are</h2>
          <p>
            PlanBanLo is more than a travel platform — it’s a journey into the
            heart of the Himalayas. We design immersive retreats that combine
            yoga, adventure, mindfulness, and digital detox to help you step
            away from chaos and step into clarity.
          </p>
        </div>
      </section>
    
      {/* Mission & Vision Combined */}
      <section className="about-split">
        <div className="about-box">
          <h2>Our Mission</h2>
          <p>
            To create transformational outdoor experiences where mental clarity,
            physical wellness, and natural beauty come together in harmony.
          </p>
        </div>

        <div className="about-box">
          <h2>Our Vision</h2>
          <p>
            To become India’s most trusted Himalayan retreat brand, inspiring
            people to explore, heal, and grow through nature-led experiences.
          </p>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="about-why">
        <div className="about-content">
          <h2>Why Choose PlanBanLo?</h2>
          <p className="why-intro">
            At PlanBanLo, we don’t just organize trips — we design transformative
            Himalayan experiences. Every retreat is thoughtfully curated to ensure
            safety, authenticity, comfort, and meaningful connection.
          </p>

          <div className="why-grid">
            <div className="why-card">
              <h3>Curated Himalayan Locations</h3>
              <p>
                We handpick serene mountain destinations that offer breathtaking
                landscapes, peaceful surroundings, and an authentic connection with nature.
              </p>
            </div>

            <div className="why-card">
              <h3>Certified Wellness Experts</h3>
              <p>
                Our retreats are guided by experienced yoga instructors and wellness
                facilitators who ensure a safe and enriching practice for all levels.
              </p>
            </div>

            <div className="why-card">
              <h3>Safe & Guided Adventures</h3>
              <p>
                From camping logistics to local guidance, our experienced team ensures
                every adventure is organized with the highest safety standards.
              </p>
            </div>

            <div className="why-card">
              <h3>Small, Intentional Groups</h3>
              <p>
                We keep our group sizes limited to create deeper connections,
                personalized attention, and a more intimate retreat experience.
              </p>
            </div>

            <div className="why-card">
              <h3>Digital Detox & Mindful Living</h3>
              <p>
                Disconnect from screens and reconnect with yourself. Our retreats
                encourage mindfulness, stillness, and meaningful presence in nature.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="about-team">
        <div className="team-container">
          <h2>Meet Our Team</h2>

          <div className="team-cards">
            <div className="team-card">
              <img src="" alt="Founder Naveen Yadav" />
              <h3>Naveen Yadav</h3>
              <p>Founder & Visionary</p>
              <span>
                Passionate about building soulful travel experiences rooted in
                nature and wellness.
              </span>
            </div>

            <div className="team-card">
              <img src={YugrajSaini} alt="Yugraj Saini" />
              <h3>Yugraj Saini</h3>
              <p>Retreat Coordinator</p>
              <span>
                Ensuring every retreat runs smoothly with attention to comfort,
                safety, and experience.
              </span>
            </div>
            

            <div className="team-card">
              <img src="" alt="Mayank Choudhary" />
              <h3>Mayank Choudhary</h3>
              <p>Operations & Logistics</p>
              <span>
                Managing ground operations and making Himalayan adventures
                seamless.
              </span>
            </div>
          </div>
        </div>
      </section>

    </>
  );
}

export default About;